import type { AuthUser } from '@stayon/auth-core';
import { can, canAccess, isPlatformAdmin, isPlatformWorkspace } from '@/shared/auth';
import { settingsNavigation, type SettingsNavItem } from './settingsNavigation';

/**
 * Sichtbarkeit eines Hub-Eintrags. Bewusst hier und nicht in den Konsumenten: Sub-Sidebar und
 * Hub-Kacheln müssen dieselbe Antwort geben, sonst zeigt die eine Fläche etwas, das die andere
 * verbirgt. Plattformeinträge verlangen zusätzlich den Workspace-Typ (Server: RequirePlatformAdmin).
 */
export function isSettingsItemVisible(user: AuthUser | null, item: SettingsNavItem): boolean {
  if (item.privilege) {
    return can(user, item.privilege);
  }
  if (item.platformOnly) {
    return isPlatformAdmin(user);
  }
  if (item.platformWorkspaceOnly) {
    return isPlatformWorkspace(user) && canAccess(user, item.roles);
  }
  return canAccess(user, item.roles);
}

const settingsPaths = settingsNavigation.flatMap((group) => group.items.map((item) => item.to));

/**
 * True, wenn der Pfad zum Einstellungen-Hub gehört (Index, /settings/*, sowie die
 * hub-internen Nicht-/settings-Routen wie /users, /companies, /system/audit …).
 * Steuert die Aktiv-Hervorhebung des Haupt-Nav-Eintrags „Einstellungen".
 * `/system/onboarding-links` gehört bewusst NICHT dazu — das ist Kommunikation.
 */
export function isSettingsPath(path: string): boolean {
  if (path === '/settings' || path.startsWith('/settings/')) return true;
  return settingsPaths.some((base) => path === base || path.startsWith(`${base}/`));
}
